// Colours
import { offWhite } from "Constants/ColourConstants";
import { styles as textStyles } from "Common/Styles/TextStyles";

export const styles = {
  title: {
    ...textStyles.poppinsTitle,
    textAlign: "left",
    width: "100%",
    fontSize: { xs: "1.5rem", sm: "2rem" },
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  navBar: {
    background: offWhite,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    zIndex: 1000,
    justifyContent: "center",
  },
};
